var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCleverIcon = function SvgCleverIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.178 7.145C22.139 3.396 18.058.93 13.207.93 6.42.93.93 6.318.93 12.995s5.489 12.066 12.276 12.078c4.853 0 8.933-2.467 10.973-6.215l-4.216-2.303c-1.403 2.4-3.678 3.913-6.757 3.913-4.147 0-7.393-3.384-7.393-7.467 0-4.082 3.246-7.466 7.393-7.466 3.079 0 5.354 1.512 6.757 3.912l4.215-2.302Z",
    fill: "#fff"
  })));
};
export default SvgCleverIcon;